<div class="container v2-active">
    <div class="row my-1 d-flex">
        <div class="col-8">
            <h1>{{ 'dialogs.telegram.title' | transloco }}</h1>
        </div>
        <div class="col-4 d-flex justify-content-end">
            <a (click)="fechar()" [attr.aria-label]="'dialogs.telegram.closeAria' | transloco">
                <mat-icon>close</mat-icon>
            </a>
        </div>
    </div>

    <form class="form" [formGroup]="form">
        <div class="row">
            <div class="col-12">
                <div class="bd-callout bd-callout mt-0 mb-5">
                    <b>{{ 'dialogs.telegram.tokenTitle' | transloco }}</b> <br /> <br />
                    <span>{{ 'dialogs.telegram.tokenDescription' | transloco }}</span> <br>
                    <span>{{ 'dialogs.telegram.tokenExample' | transloco }}</span>
                </div>
            </div>
        </div>

        <div class="row d-flex align-items-baseline justify-content-center">
            <div class="col-12 col-md-8">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="fixed">
                    <mat-label>{{ 'dialogs.telegram.tokenLabel' | transloco }}</mat-label>
                    <input type="text" formControlName="telegram_bot_token" matInput
                        [placeholder]="'dialogs.telegram.tokenPlaceholder' | transloco">
                    <mat-error>{{ 'dialogs.telegram.tokenRequired' | transloco }}</mat-error>
                </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
                <button mat-stroked-button color="secondary"
                    class="py-4 w-100" (click)="buscarChatID()">
                    @if(!isLoading){
                        <span>{{ 'dialogs.telegram.searchChatId' | transloco }}</span>
                    }
                    @if(isLoading){
                        <mat-progress-spinner  mode="indeterminate" [diameter]="30"></mat-progress-spinner>
                    }
                </button>
            </div>
        </div>

        @if(dados.telegram_chat_id){
            <div class="row my-3 my-md-1 d-flex">
                <div class="col-12">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'dialogs.telegram.chatIdLabel' | transloco }}</mat-label>
                        <input type="text" formControlName="telegram_chat_id" matInput
                            [placeholder]="'dialogs.telegram.chatIdPlaceholder' | transloco">
                        <mat-error>{{ 'dialogs.telegram.chatIdRequired' | transloco }}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        }

        <div class="row d-flex justify-content-end mt-3">
            <div class="col-12 d-flex justify-content-end">
                <button mat-stroked-button color="secondary" (click)="fechar()" class="m-2">{{ 'dialogs.telegram.cancel' | transloco }}</button>
                <button [disabled]="form.invalid" mat-stroked-button (click)="salvar()" class="m-2">{{ 'dialogs.telegram.save' | transloco }}</button>
            </div>
        </div>
    </form>
</div>
